import { useEffect, useRef } from 'react';
import useDragPreviewManagerValue from 'layout-dnd-utils/DragPreview/useDragPreviewManagerValue';
import { useDragPreviewManager } from 'layout-dnd-utils/DragPreview/DragPreviewManager';
const useScrollPosition = () => {
  const scrollPositionRef = useRef({
    initialLeft: window.scrollX,
    initialTop: window.scrollY,
    adjustedLeft: 0,
    adjustedTop: 0,
    currentLeft: window.scrollX,
    currentTop: window.scrollY
  });
  useEffect(() => {
    const handleScroll = () => {
      scrollPositionRef.current.adjustedLeft = window.scrollX - scrollPositionRef.current.initialLeft;
      scrollPositionRef.current.adjustedTop = window.scrollY - scrollPositionRef.current.initialTop;
      scrollPositionRef.current.currentLeft = window.scrollX;
      scrollPositionRef.current.currentTop = window.scrollY;
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return scrollPositionRef.current;
};
/**
 * Renders a shadowed drag preview of the element to be dragged, with the same
 * size and position as the dragged element. The dragged element is updated to
 * then follow the cursor position when the cursor is moved.
 */
const DragPreview = ({
  scale = 1,
  element,
  sourceClientOffset,
  differenceFromInitialOffset
}) => {
  const dragPreviewManager = useDragPreviewManager();
  const zIndex = useDragPreviewManagerValue(_dragPreviewManager => _dragPreviewManager.getDragPreviewZIndex());
  const {
    adjustedLeft,
    adjustedTop,
    currentLeft,
    currentTop
  } = useScrollPosition();

  // Updates the dragged element to follow the cursor position when the cursor
  // is moved. It's adjusted to account for a cursor offset and scroll position.
  useEffect(() => {
    if (element && differenceFromInitialOffset && sourceClientOffset) {
      const x = (differenceFromInitialOffset.x + adjustedLeft) / scale;
      const y = (differenceFromInitialOffset.y + adjustedTop) / scale;
      dragPreviewManager.setDragPreviewPosition({
        elementLeft: sourceClientOffset.x + currentLeft,
        elementTop: sourceClientOffset.y + currentTop
      });
      element.style.transform = `translate(${x}px, ${y}px)`;
      element.style.zIndex = zIndex;
      element.style.opacity = '0.8';
    }
    return () => {
      if (element) {
        element.style.removeProperty('z-index');
        element.style.removeProperty('transform');
        element.style.removeProperty('opacity');
      }
    };
  }, [element, adjustedLeft, adjustedTop, currentLeft, currentTop, zIndex, scale, differenceFromInitialOffset, sourceClientOffset, dragPreviewManager]);
  return null;
};
export default DragPreview;